<!-- Structure, classes and building blocks follow `pages/companies-list/companies-list2.component.html`. -->
<div class="tabs-container">
    <div class="tab" data-testid="persons-tab-active" [class.active]="!showInactive" (click)="selectTab(false)">
        <span>{{ local.aumico_persons_overview_tab_active | i18next }}</span>
        <!-- Only the number (companies show "n/licences"; persons have no licences). Badge colour:
             primary on the chosen tab, grey otherwise — as `inactiveColor` in companies-list2. -->
        <span hamBadge [color]="showInactive ? 'grey' : 'primary'">{{ activeCount }}</span>
    </div>
    <div class="tab" data-testid="persons-tab-inactive" [class.active]="showInactive" (click)="selectTab(true)">
        <span>{{ local.aumico_persons_overview_tab_inactive | i18next }}</span>
        <span hamBadge [color]="showInactive ? 'primary' : 'grey'">{{ inactiveCount }}</span>
    </div>
</div>

<!-- REV-22155: slot under the tabs, e.g. the progress banner of "Nächstes Geschäftsjahr" (as in companies) -->
<ng-content select="[belowTabs]"></ng-content>

<div class="page-wrapper" #pageWrapper>
    <div class="page-header">
        <form (ngSubmit)="submitSearch()">
            <input
                hamInput
                data-testid="persons-search"
                icon="/assets/hamIcons/search-outline.svg"
                [formControl]="searchControl"
                placeholder="{{ local.aumico_persons_overview_search | i18next }}"
                (cancel)="clearSearch()"
                [shouldHighliteBlueWhenValueEntered]="true"
            />
        </form>
        <div class="d-flex">
            <user-filter-drop-down
                data-testid="persons-filter-assignee"
                [label]="local.aumico_persons_overview_filter_assignee | i18next"
                [users]="assigneeOptions"
                [selectedUserIds]="assigneeFilterIds"
                [view]="'companies'"
                (userChange)="onAssigneeFilter($event)"
                (searchChange)="searchAssigneeOptions($event)"
            ></user-filter-drop-down>
            <user-filter-drop-down
                data-testid="persons-filter-clerk"
                [label]="local.aumico_persons_overview_filter_clerk | i18next"
                [users]="clerkOptions"
                [selectedUserIds]="clerkFilterIds"
                [view]="'companies'"
                (userChange)="onClerkFilter($event)"
                (searchChange)="searchClerkOptions($event)"
            ></user-filter-drop-down>
            <!-- Tag filter: the same dropdown (search, checkboxes, "Anwenden" / "Löschen"), without avatars. -->
            <user-filter-drop-down
                data-testid="persons-filter-tag"
                [label]="local.aumico_persons_overview_filter_tag | i18next"
                [users]="tagOptions"
                [selectedUserIds]="tagFilterIds"
                [showAvatar]="false"
                [view]="'companies'"
                (userChange)="onTagFilter($event)"
                (searchChange)="searchTagOptions($event)"
            ></user-filter-drop-down>

            <ham-button data-testid="persons-export" [variant]="'white'" icon="assets/hamIcons/arrow-down-to-bracket-outline.svg" (buttonClick)="exportClick.emit()">
                {{ local.aumico_persons_overview_export | i18next }}
            </ham-button>
            <ham-button data-testid="persons-new" icon="assets/hamIcons/plus-outline.svg" type="button" (buttonClick)="newClick.emit()">
                {{ local.aumico_persons_overview_new | i18next }}
            </ham-button>
        </div>
    </div>

    <div class="page-content">
        <!-- No "…" menu per row (context §9). -->
        <ham-table-with-actions
            *ngIf="persons.length > 0"
            [dataSource]="persons"
            [pagination]="false"
            (rowSelected)="onRowClick($event)"
            [columnClasses]="columnClasses"
            hideActions="true"
            [tableStyles]="'min-width: 700px; table-layout: fixed'"
        >
            <tr groupHeaderRow class="group-header-row">
                <th class="hamScaleColLarge">
                    <div style="display: flex; align-items: center">
                        <span
                            *ngIf="!showInactive"
                            class="person-checkbox"
                            (click)="$event.stopPropagation(); toggleAll()"
                        >
                            <span hamCheckbox [checked]="allSelected" (change)="toggleAll()"></span>
                        </span>
                        {{ local.aumico_persons_overview_col_name | i18next }}
                    </div>
                </th>
                <th class="hamScaleColSmall">{{ local.aumico_persons_overview_col_street | i18next }}</th>
                <th class="hamTextCol100">{{ local.aumico_persons_overview_col_zip | i18next }}</th>
                <th class="hamTextCol150">{{ local.aumico_persons_overview_col_city | i18next }}</th>
                <th class="hamTextCol150">{{ local.aumico_persons_overview_col_tag | i18next }}</th>
                <th class="hamScaleColResponsible">{{ local.aumico_persons_overview_col_assignee | i18next }}</th>
                <th class="hamScaleColResponsible">{{ local.aumico_persons_overview_col_clerk | i18next }}</th>
            </tr>

            <ng-template hamCell let-element>
                <div style="display: flex; align-items: center" [ngClass]="{ selected: selectedIds.has(element._id) }">
                    <span *ngIf="!showInactive" class="person-checkbox" data-testid="persons-row-checkbox" (click)="toggleRow(element._id, $event)">
                        <span class="checkBox" hamCheckbox [checked]="selectedIds.has(element._id)" [bubbleEvents]="true"></span>
                    </span>
                    <span class="person-name">{{ element.name || '-' }}</span>
                </div>
            </ng-template>
            <ng-template hamCell let-element>
                <span
                    #streetCell
                    class="truncate-text"
                    [hamTooltip]="streetCell.scrollWidth > streetCell.clientWidth ? element.street : null"
                    >{{ element.street || '-' }}</span
                >
            </ng-template>
            <ng-template hamCell let-element>{{ element.zip || '-' }}</ng-template>
            <ng-template hamCell let-element>{{ element.city || '-' }}</ng-template>
            <!-- Tag column: pills as in the prototype, display only (no "×"). -->
            <ng-template hamCell let-element>
                <div class="tag-cell">
                    <ham-tag-pill *ngFor="let tagName of element.tagNames" [label]="tagName"></ham-tag-pill>
                </div>
            </ng-template>
            <ng-template hamCell let-element>
                <ng-container
                    *ngTemplateOutlet="userCell; context: { $implicit: element, field: 'assignee', id: element.assigneeId, name: element.assigneeName }"
                ></ng-container>
            </ng-template>
            <ng-template hamCell let-element>
                <ng-container
                    *ngTemplateOutlet="userCell; context: { $implicit: element, field: 'clerk', id: element.clerkId, name: element.clerkName }"
                ></ng-container>
            </ng-template>
        </ham-table-with-actions>

        <div class="empty-state-wrapper" *ngIf="persons.length === 0">
            <div class="empty-state">
                <span class="file-circle-plus-outline-wrapper" hamIconShapes icon="assets/hamIcons/user.svg" [size]="'50px'"></span>
                <div class="text1">{{ local.aumico_persons_overview_empty_text1 | i18next }}</div>
                <div class="text2">{{ local.aumico_persons_overview_empty_text2 | i18next }}</div>
                <ham-button type="button" icon="assets/hamIcons/plus-outline.svg" (buttonClick)="newClick.emit()">
                    {{ local.aumico_persons_overview_new | i18next }}
                </ham-button>
            </div>
        </div>
    </div>
</div>

<!-- Mandatsleiter / Sachbearbeiter in the row: button + flyout, as in companies-list2. -->
<ng-template #userCell let-element let-field="field" let-id="id" let-name="name">
    <div class="dropdown-wrapper assignee">
        <ham-button
            #userButton
            class="assignee-button"
            size="xs"
            variant="white"
            (buttonClick)="openUserFlyout(element._id, field, userButton)"
            (click)="$event.stopPropagation()"
        >
            <span class="inner-assignee-wrapper">
                <span class="avatar_and_name">
                    <span class="avatar">{{ getInitials(name) }}</span>
                    <span class="name-display">{{ name || '-' }}</span>
                </span>
                <span class="ham-icon"><i class="chevron-down-icon"></i></span>
            </span>
        </ham-button>
    </div>
    <span
        class="menu-flyout"
        hamFlyout
        *ngIf="isFlyoutOpen(element._id, field)"
        [position]="flyoutPosition"
        (closeFlyout)="closeUserFlyout()"
    >
        <div class="flyout-user-options-content">
            <div
                *ngFor="let user of users"
                class="status-option assignee"
                [class.selected]="user.id === id"
                (click)="chooseUser(element, user.id); $event.stopPropagation()"
            >
                <span class="avatar">{{ getInitials(user.name) }}</span>
                <span class="name">{{ user.name }}</span>
            </div>
        </div>
    </span>
</ng-template>

<bulk-edit-action-bar
    *ngIf="selectedIds.size > 0"
    [selectedCount]="selectedIds.size"
    [actions]="bulkActions"
    [deleteAction]="deactivateAction"
    deleteActionIcon="assets/hamIcons/moon-outline.svg"
    [textSelectedTranslationKey]="local.aumico_persons_overview_bulk_selected"
    [globalPosition]="true"
    (actionClicked)="onBulkAction($event)"
></bulk-edit-action-bar>

<!-- Bulk change of Mandatsleiter / Sachbearbeiter — same modal as companies. -->
<ham-modal
    *ngIf="openBulkDialog"
    [title]="
        (openBulkDialog === 'assignee'
            ? local.aumico_persons_overview_bulk_assignee_title
            : local.aumico_persons_overview_bulk_clerk_title
        ) | i18next: { count: selectedIds.size }
    "
    [cancelText]="local.aumico_persons_overview_cancel | i18next"
    [showCancelButton]="true"
    [saveText]="local.aumico_persons_overview_save | i18next"
    [disabled]="!bulkUserControl.value"
    (cancel)="cancelBulkUser()"
    (save)="confirmBulkUser()"
>
    <input
        hamSimpleDropDown
        [label]="
            (openBulkDialog === 'assignee'
                ? local.aumico_persons_overview_filter_assignee
                : local.aumico_persons_overview_filter_clerk
            ) | i18next
        "
        [options]="users"
        [optionKeys]="['name']"
        returnKey="id"
        [returnObject]="true"
        [placeholder]="local.aumico_persons_overview_please_choose | i18next"
        [formControl]="bulkUserControl"
    />
</ham-modal>

<!-- Bulk deactivate — same confirmation as the companies overview. -->
<ham-confirm-decline-modal
    *ngIf="showBulkDeactivateDialog"
    (cancel)="confirmBulkDeactivate(false)"
    (action)="confirmBulkDeactivate(true)"
    footerAlignment="center"
    actionBtnText="{{ local.aumico_persons_overview_bulk_deactivate | i18next }}"
    noActionBtnText="{{ local.aumico_persons_overview_cancel | i18next }}"
>
    <ham-general-confirm-decline-modal-body
        [text]="local.aumico_persons_overview_bulk_deactivate_confirm | i18next: { count: selectedIds.size }"
    ></ham-general-confirm-decline-modal-body>
</ham-confirm-decline-modal>

<!-- Sachbearbeiter change with CPMM: which tasks follow — same dialog as the companies overview. -->
<ham-modal
    *ngIf="pendingClerkChange"
    [saveText]="'aumico_company_assignee_change_confirmation_dialog_save_button' | i18next"
    [size]="'default'"
    [showCancelButton]="true"
    [cancelText]="'aumico_licence_banner_dialog_close_button' | i18next"
    (cancel)="cancelClerkChange()"
    (save)="confirmClerkChange()"
>
    <div class="task-reassignment">
        <h3>{{ 'aumico_company_assignee_change_confirmation_dialog_title' | i18next }}</h3>
        <span class="description">{{ 'aumico_persons_form_clerk_change_dialog_text' | i18next }}</span>
        <label class="option-card" (click)="selectedTaskUpdate = tasksUpdateOption.UPDATE_TASKS_ASSIGNED_TO_CURRENT">
            <div class="content">
                <div class="title">
                    {{ 'aumico_company_assignee_change_confirmation_update_tasks_assigned_to_current_user' | i18next }}
                </div>
                <div class="description">
                    {{
                        'aumico_company_assignee_change_confirmation_update_tasks_assigned_to_current_user_description_text'
                            | i18next
                    }}
                </div>
            </div>
            <input
                type="radio"
                name="persons-task-reassignment"
                [checked]="selectedTaskUpdate === tasksUpdateOption.UPDATE_TASKS_ASSIGNED_TO_CURRENT"
            />
        </label>
        <label class="option-card" (click)="selectedTaskUpdate = tasksUpdateOption.UPDATE_ALL_TASKS">
            <div class="content">
                <div class="title">{{ 'aumico_company_assignee_change_confirmation_update_all_tasks' | i18next }}</div>
                <div class="description">
                    {{ 'aumico_company_assignee_change_confirmation_update_all_tasks_description_text' | i18next }}
                </div>
            </div>
            <input
                type="radio"
                name="persons-task-reassignment"
                [checked]="selectedTaskUpdate === tasksUpdateOption.UPDATE_ALL_TASKS"
            />
        </label>
    </div>
</ham-modal>
